import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewDiscountPageNew from "../../components/ManageDiscount/ViewDiscountPageNew";



const ViewDiscountPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Discount Management" link2="/discount" title="View Discount " />

        {/* AddUserLayer */}
        <ViewDiscountPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewDiscountPage;
